import React, { PureComponent, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Collapse } from "antd";
import moment from "moment";
import "moment/locale/fr";
import { connect } from "react-redux";
import _ from "lodash";
import { visitsApiUpsellProvider } from "./../../lib/api/providers";
import ListHistory from "./../../containers/activite/visit/PreviewListHistoryContainer";

import "react-viewer/dist/index.css";
import { extractStatementsFromVisits, get } from "./Preview.utils";

import {
  renderMedia,
  renderVendors,
  renderFamily,
  renderTableKpis,
  renderMerch,
  renderLocationTypeReponse,
  renderEndVisitStatement
} from "./Preview.render";
import VisitPreviewFormio from "./PreviewFormio";

const { Panel } = Collapse;

class VisitPreview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      listHistory: [],
      historyLoading: true,
      currentVisit: null
    };
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.currentClient &&
      this.state.currentVisit &&
      prevProps.currentClient.id !== this.state.currentVisit.client_id
    ) {
      this.props.history.push("/visit");
    }
  }
  async componentDidMount() {
    const currentVisitId = this.props.match.params.id;

    if (!currentVisitId) {
      this.props.history.push("/visit");
      return;
    }

    const responseVisit = await visitsApiUpsellProvider.post("/", { match: { _id: currentVisitId } });
    if (!Array.isArray(responseVisit.data) || responseVisit.data.length !== 1) {
      alert("Visite non reconnue");
      this.props.history.push("/visit");
      return;
    }

    const currentVisit = responseVisit.data[0];
    await this.setState({ currentVisit });

    const currentClientId = this.props.currentClient ? this.props.currentClient.id : undefined;

    await visitsApiUpsellProvider
      .post(`/`, {
        match: { pdc_id: currentVisit.pdc_id, client_id: currentClientId },
        limit: 100,
        sort: { _id: -1 }
      })
      .then((response = {}) => {
        this.setState({
          historyLoading: false,
          listHistory: response.data
        });
      })
      .catch(e => {
        this.setState({
          historyLoading: false
        });
      });
  }

  renderStatement = (
    {
      locationLabel,
      statementLabel,
      data,
      medias,
      locationTypeResponse,
      locationId,
      locationTypeId,
      moduleData,
      brandsData,
      categoriesData,
      familiesData,
      question,
      vendors,
      statementId
    },
    familiesList,
    categoriesList,
    brandsList,
    currentVisit
  ) => {
    locationLabel = locationLabel || "";
    statementLabel = statementLabel || "";

    const path = { locationTypeId, locationId, statementId };
    const itemRender = (
      <Fragment key={locationLabel + "-" + statementLabel}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <u style={{ paddingBottom: 5, fontWeight: "bold", fontSize: 16 }}>{question}</u>
          <span style={{ marginVertical: 10 }}> </span>
        </div>
        {Array.isArray(categoriesData) && categoriesData.length > 0
          ? renderTableKpis({
              data: categoriesData,
              name: "Categories",
              source: "category",
              itemListWithDuplication: categoriesList,
              path,
              visitId: currentVisit._id
            })
          : null}
        {Array.isArray(familiesData) && familiesData.length > 0
          ? renderTableKpis({
              data: familiesData,
              name: "Familles",
              source: "family",
              itemListWithDuplication: familiesList,
              path,
              visitId: currentVisit._id
            })
          : null}
        {Array.isArray(brandsData) && brandsData.length > 0
          ? renderTableKpis({
              data: brandsData,
              name: "Marques",
              source: "brand",
              itemListWithDuplication: brandsList,
              path,
              visitId: currentVisit._id
            })
          : null}
        {data.map(family => renderFamily({ family, familiesList, path, currentVisit }))}
        {renderMerch(moduleData)}
        {renderMedia({ medias, currentVisit, path })}
        {renderLocationTypeReponse({ locationTypeResponse, visitId: currentVisit._id, path })}
        {renderVendors(vendors)}
      </Fragment>
    );
    const header = locationLabel.toUpperCase() + " - " + statementLabel.toUpperCase();
    return { item: itemRender, header, key: `${locationLabel}-${statementLabel}` };
  };
  renderVisit = (currentVisit = {}) => {
    console.log(currentVisit, "currentVisit");
    if (currentVisit.source === "formio") return <VisitPreviewFormio currentVisit={currentVisit} />;
    const statements = [];

    const { locationsData, familiesList, categoriesList, brandsList } = extractStatementsFromVisits(currentVisit);

    for (let i = 0; i < locationsData.length; i++) {
      const locationsDatum = locationsData[i];
      statements.push(this.renderStatement(locationsDatum, familiesList, categoriesList, brandsList, currentVisit));
    }
    if (currentVisit.end_visit_statement) {
      const endVisitStatementInfo = renderEndVisitStatement({ currentVisit });
      if (endVisitStatementInfo) statements.push(endVisitStatementInfo);
    }
    return (
      <div className="p-visit-detail">
        <Collapse defaultActiveKey={Array.isArray(statements) && statements[0] ? statements[0].key : undefined}>
          {statements.map((elem, i) => (
            <Panel key={elem.key} header={elem.header} className="p-visit-detail-location">
              {elem.item}
            </Panel>
          ))}
        </Collapse>
      </div>
    );
  };

  render() {
    if (!this.state.currentVisit) {
      return null;
    }
    const {
      user_fullName,
      pdc_label,
      pdc_adresse,
      startDate,
      endDate,
      source,
      surveyId,
      title
    } = this.state.currentVisit;
    const surveyName = source === "formio" ? surveyId : title;
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div className="p-visit-detail-header">
          <div className="p-content-page-center-header">
            <h2 className="p-content-page-center-header-title">Détails d'une visite</h2>
          </div>
          <div className="p-content-page-center-content p-mrg-top">
            <div>
              Visite de <span className="p-clr-dm">{user_fullName || " - "}</span> à{" "}
              <span className="p-clr-dm">{pdc_label || ""}</span> ({`${pdc_adresse || ""}`}
              ).
            </div>
            <div className="p-mrg-top-s p-mrg-bot">
              Commencée le <span className="p-clr-dm">{moment(startDate).format("Do MMMM YYYY HH:mm:ss")}</span> et
              terminée le <span className="p-clr-dm">{moment(endDate).format("Do MMMM YYYY HH:mm:ss")}</span> (
              {moment(endDate).diff(moment(startDate), "minutes")} minutes).
            </div>
            <div>Nom du questionnaire : {surveyName || "sans nom"}</div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div class={`p-content-page-center`}>
            <div style={{ marginTop: 150 }} className="p-w-100 p-mrg-top-l">
              {this.renderVisit(this.state.currentVisit)}
            </div>
          </div>
          <div style={{ marginTop: 135 }} class="p-content-page-right">
            <div className="p-content-page-right-banner">
              <h3 class="p-content-page-right-title">Historique des visites ({this.state.listHistory.length})</h3>
              <ListHistory
                defaultText={"Aucune visite"}
                loading={this.state.historyLoading}
                currentVisit={this.state.currentVisit}
                listHistory={this.state.listHistory}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClient: state.currentClient
  };
};

export default connect(mapStateToProps)(withRouter(VisitPreview));



// WEBPACK FOOTER //
// src/components/visit/Preview.js